import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { productPortfolio } from "../../data/mock";
import { getIcon } from "../../data/iconMap";
import SectionHeading from "../ui-custom/SectionHeading";
import GlassCard from "../ui-custom/GlassCard";
import Reveal from "../ui-custom/Reveal";

const ProductPortfolioSection = () => {
  return (
    <section className="relative py-24 md:py-28 px-6">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Product Portfolio"
          title="Engineered For The Grid"
          subtitle="Three integrated lines covering power products, power quality, and the corporate foundation behind them."
        />
        <div className="grid md:grid-cols-3 gap-6">
          {productPortfolio.map((p, i) => {
            const Icon = getIcon(p.icon);
            return (
              <Reveal key={p.slug} delay={i * 0.1}>
                <GlassCard tilt className="p-8 h-full flex flex-col">
                  <span className="w-14 h-14 rounded-xl flex items-center justify-center bg-qamber/10 border border-qamber/25 mb-6">
                    <Icon size={26} className="text-qamber" />
                  </span>
                  <h3 className="font-display font-bold uppercase tracking-wide text-xl text-foreground mb-3">{p.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed mb-6">{p.description}</p>

                  <div className="flex gap-6 mb-6">
                    {p.stats.map((s) => (
                      <div key={s.label}>
                        <div className="font-display font-bold text-2xl glow-text-cyan">{s.value}</div>
                        <div className="text-xs text-muted-foreground uppercase tracking-wide mt-1">{s.label}</div>
                      </div>
                    ))}
                  </div>

                  <ul className="flex flex-wrap gap-2 mb-8">
                    {p.items.map((it) => (
                      <li key={it} className="text-xs text-muted-foreground border border-border/10 rounded-full px-3 py-1">
                        {it}
                      </li>
                    ))}
                  </ul>

                  <Link
                    to={p.slug === "corporate" ? "/about-us" : `/${p.slug}`}
                    className="mt-auto inline-flex items-center gap-2 text-qcyan font-semibold text-sm tracking-wide hover:gap-3 transition-all"
                  >
                    Explore {p.title} <ArrowRight size={16} />
                  </Link>
                </GlassCard>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProductPortfolioSection;
